import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import "./Configuration.css"

const Configuration = (props) => {
  const card = useSelector((state) => state.config.card)
  const hover = useSelector((state) => state.config.hover)
  const imgPrefix = useSelector((state) => state.imgPrefix)
  const urlPrefix = useSelector((state) => state.urlPrefix)
  const selected = useMemo(
    () =>
      props.type === "configurable"
        ? props.upperProduct[props.configurableAttribute] === props.child
        : props.child.data.sku === props.upperProduct.sku,
    [props]
  )
  const configAttribute = useMemo(() => {
    return hover.attributes.filter(
      (item) => item.key === props.configurableAttribute
    )[0]
  }, [props, hover])
  const imageToShow = useMemo(() => {
    return props.selectedProduct &&
      props.selectedProduct?.[card?.img?.key] &&
      props.selectedProduct[card.img.key].length > 0
      ? props.selectedProduct[card.img.key][0]?.replace("{:image}", imgPrefix)
      : ""
  }, [props, imgPrefix, card])

  return (
    <a
      className={
        "configuration" +
        (selected ? " selected" : "") +
        (props.isImpossible ? " impossible" : "") +
        (props.type !== "configurable" || configAttribute.type !== "value"
          ? " with-image"
          : "")
      }
      onMouseEnter={() => props.setSelectedProduct(props.child)}
      href={props.selectedProduct[card.url.key].replace("{:url}", urlPrefix)}
      onClick={(evt) => evt.stopPropagation()}
    >
      {props.type === "configurable" && configAttribute.type === "value" ? (
        props.child
      ) : (
        <img src={imageToShow} alt={props.selectedProduct[card.title.key]} />
      )}
    </a>
  )
}

export default Configuration
